const heJSSelectors = {};
class heJS extends HTMLElement {
      constructor() {
        super();
        this.tsvheavyEqJSON();
    }

    async tsvheavyEqJSON(){
        let json = await vehicleUtility.tsvheavyEqJSON();
        this.initHeavyEq(json);
      }

    initHeavyEq(json){
    this.heavyEquipmentJsonData =  json;
    this.defaultMaterial = window.globalVariables.default_material;

    this.uniqueCategory = [
        ...new Set(Object.values(this.heavyEquipmentJsonData).map((item) => item.equipment_category.trim()))
    ];
    this.uniqueManufacture = [
        ...new Set(Object.values(this.heavyEquipmentJsonData).map((item) => item.equipment_manufacturer)),
    ];
    this.uniqueModelNumber = [
        ...new Set(Object.values(this.heavyEquipmentJsonData).map((item) => item.equipment_model_number)),
    ];

    this.uniqueEquipmentParts = [
        ...new Set(Object.values(this.heavyEquipmentJsonData).map((item) => item.equipment_part_number))
    ];


    this.typeSelect = this.querySelector("[data-heavy-category-select-filter]");
    this.manufacturerSelect = this.querySelector("[data-heavy-manufacturer-select-filter]");
    this.modelNumberSelect = this.querySelector("[data-heavy-model-select-filter]");
    this.partNumberSelect = this.querySelector("[data-equipment-part-filter-select]");
    let equipTypeHTML = '';
   
    this.uniqueCategory.sort().forEach((category) => {
        if( category != null){
            let categoryVal = Utility._createSlug(category);
            equipTypeHTML += `
            <li class="for-check" data-value="${category}">
                <input type="radio" class="heavy-input form-check-input d-none" value="${category}" data-label="${category}" id="heavy-${categoryVal}" name="heavy-filter-type" />
                <label class="option_txt form-check-label text-capitalize" for="heavy-${categoryVal}" title="Label for ${categoryVal}">${category}</label>
            </li>
            `;
        }
    });

    if(this.typeSelect != null){
        this.typeSelect.innerHTML = equipTypeHTML;
        this.typeOptions = this.typeSelect.querySelectorAll('li');
        this.typeOptions.forEach((option) => {
            option.addEventListener('click', (event) => {
                let _this = event.currentTarget;
                this.typeOptions.forEach(option => option.classList.remove('selected'));
                _this.classList.add('selected');
                _this.closest('.custom-dropdown').querySelector('.heavy-equip-default .option_txt').innerHTML = _this.querySelector('.option_txt').innerHTML;
                this.selectContainer = _this.closest('.custom--select');
                Utility.toggleElement(this.selectContainer, 'close');
            });
        });
        this.typeInputs = this.typeSelect.querySelectorAll('input');
      
        this.typeInputs.forEach((typeInput) => {
            typeInput.addEventListener('change', (event) => {
                let _this = event.currentTarget;
                document.querySelector('[data-shop-heavy-btn]')?.classList.add('disabled');
                document.querySelector('[data-edit-shop-heavy-btn]')?.classList.add('disabled');

                let currentvalue = document.querySelector('[data-heavy-category-select-filter] [name="heavy-filter-type"]:checked').value;
                let currentvalueLabel = document.querySelector('[data-heavy-category-select-filter] [name="heavy-filter-type"]:checked').getAttribute('data-label');
                let els = document.querySelectorAll('shop-heavy-equipment');
                els.forEach(el => {
                    
                    el.querySelector('[data-shop-heavy-btn]')?.classList.add('disabled');
                    el.querySelector('[data-shop-heavy-btn-new]')?.classList.add('disabled');
                    el.querySelector('[data-pdp-edit-heavy-btn]')?.classList.add('disabled');
                    el.querySelector('.manufacturer-default .option_txt').innerHTML = 'Manufacturer';
                    el.querySelector('.heavy-modal-default .option_txt').innerHTML = 'Model Number';
                    el.modelNumberSelect.innerHTML = '';
                    el._updateManufacture(currentvalueLabel);
                });
            })
        });
    }

     // Add a click event listener to the 'shopVehicleBtn'
     const shopVehicleBtn = document.querySelectorAll('[data-shop-heavy-btn]');
     shopVehicleBtn.forEach(button => {
        button.addEventListener('click', (event) => {
            event.target.closest('.btn').classList.add('loading');
            var isCustomer = document.body.classList.contains('customer-loggedin');
            var isCustomerB2B = document.body.classList.contains('b2b-customer');

            if(isCustomer && !isCustomerB2B){
                this._addVehicle();
            } else if(isCustomer && isCustomerB2B) {
                this._searchVehicle();
            } else {
                this._addVehicle();
            }             
        });
    });

     const shopVehicleBtnNew = document.querySelector('[data-shop-heavy-btn-new]');
     shopVehicleBtnNew.addEventListener('click', (event) => {
        event.target.closest('.btn').classList.add('loading');
        document.querySelector('[data-shop-heavy-btn]').click();
     });


     // Determine if the user is a customer based on a class
     vehicleUtility._deterMineVehicles();
     this.selectedYMMData = window.customerSelectedVehicles.vehicle
     this.selectedHeavyEqipData =  window.customerSelectedVehicles.heavyVehicle
     this.selectedSideYMMData = window.customerSelectedVehicles.sidebyside
     this.selectedTrufData = window.customerSelectedVehicles.tur
     this.defaultVehicle = false;

     if(this.selectedYMMData.length > 0){
        this.selectedYMMData.forEach((selectedYMM) => {
            if(selectedYMM.default == true){
                this.defaultVehicle = false;
            }
        })
     } else {
        // Determine if it's the default vehicle
        this.defaultVehicle = this.selectedHeavyEqipData.length === 0;
     }

    this.editHEBtn = document.querySelector('[data-edit-shop-heavy-btn]');
    if(this.editHEBtn != null){
        this.editHEBtn.addEventListener('click',(event) => {
            event.preventDefault();
            event.target.closest('.btn').classList.add('loading');
            let _this = event.currentTarget;
            this._editHEVehicle(_this);
        });
    }

    this._toggleAllDropdown();

    this.editVehcileBtn = document.querySelectorAll('[data-edit-vehcile]');
    this.editVehcileBtn.forEach((ele) => {
        ele.addEventListener('click',(event) => {
            
            event.preventDefault();
            event.stopPropagation();
            let _this = event.currentTarget;
            document.querySelector('#change-vehicle').show();
            let idToUpdate = _this.closest('[data-vehicle-id]').getAttribute('data-vehicle-id');
            const editHeavyData = this.selectedHeavyEqipData.find(vehicle => vehicle.id == idToUpdate);
            document.querySelector('#change-vehicle').setAttribute('data-id',idToUpdate)
            if(editHeavyData != undefined){
                document.querySelector('#change-vehicle .heavy-equip-default .option_txt').innerHTML = editHeavyData.equipment_category;
                document.querySelector('#change-vehicle .manufacturer-default .option_txt').innerHTML = editHeavyData.equipment_manufacturer;
                document.querySelector('#change-vehicle .heavy-modal-default .option_txt').innerHTML = editHeavyData.equipment_model_number;
                document.querySelector('#change-vehicle .year-default .option_txt').innerHTML = "Year";
                document.querySelector('#change-vehicle .make-default .option_txt').innerHTML = "Make";
                document.querySelector('#change-vehicle .model-default .option_txt').innerHTML = "Model";
                document.querySelector('#change-vehicle .trim-default .option_txt').innerHTML = "Trim";
                document.querySelector('#change-vehicle .cab-default .option_txt').innerHTML = "Cab Type";
            } 
            
        });
    });  
    }
    _toggleAllDropdown(){
        document.querySelectorAll('[data-main-category]').forEach(element => {
            element.addEventListener('click', (event) => {            
                this.querySelector('[data-manufacture-wrap] .custom-dropdown .custom--select').classList.remove('open');
                this.querySelector('[data-model-number-wrap] .custom-dropdown .custom--select').classList.remove('open');
            
                this.querySelector('[data-manufacture-wrap] .custom-dropdown.custom--select').classList.remove('open');
                this.querySelector('[data-model-number-wrap] .custom-dropdown.custom--select').classList.remove('open');
            
                this.querySelector('[data-manufacture-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
                this.querySelector('[data-model-number-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');

                this.querySelector('[data-type-wrap] .custom-dropdown .custom--select').classList.remove('open');
                this.querySelector('[data-model-number-wrap] .custom-dropdown .custom--select').classList.remove('open');
            
                this.querySelector('[data-type-wrap] .custom-dropdown.custom--select').classList.remove('open');
                this.querySelector('[data-model-number-wrap] .custom-dropdown.custom--select').classList.remove('open');
            
                this.querySelector('[data-type-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
                this.querySelector('[data-model-number-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');

                this.querySelector('[data-manufacture-wrap] .custom-dropdown .custom--select').classList.remove('open');
                this.querySelector('[data-type-wrap] .custom-dropdown .custom--select').classList.remove('open');
            
                this.querySelector('[data-manufacture-wrap] .custom-dropdown.custom--select').classList.remove('open');
                this.querySelector('[data-type-wrap] .custom-dropdown.custom--select').classList.remove('open');
            
                this.querySelector('[data-manufacture-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
                this.querySelector('[data-type-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
            });
        });

        this.querySelector('[data-type-wrap] .custom-dropdown')?.addEventListener('click', (event) => {
            this.querySelector('[data-manufacture-wrap] .custom-dropdown .custom--select').classList.remove('open');
            this.querySelector('[data-model-number-wrap] .custom-dropdown .custom--select').classList.remove('open');
           
            this.querySelector('[data-manufacture-wrap] .custom-dropdown.custom--select').classList.remove('open');
            this.querySelector('[data-model-number-wrap] .custom-dropdown.custom--select').classList.remove('open');
           
            this.querySelector('[data-manufacture-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
            this.querySelector('[data-model-number-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
         
        });
        this.querySelector('[data-manufacture-wrap] .custom-dropdown')?.addEventListener('click', (event) => {

            this.querySelector('[data-type-wrap] .custom-dropdown .custom--select').classList.remove('open');
            this.querySelector('[data-model-number-wrap] .custom-dropdown .custom--select').classList.remove('open');
           
            this.querySelector('[data-type-wrap] .custom-dropdown.custom--select').classList.remove('open');
            this.querySelector('[data-model-number-wrap] .custom-dropdown.custom--select').classList.remove('open');
           
            this.querySelector('[data-type-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
            this.querySelector('[data-model-number-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
         
        });
        this.querySelector('[data-model-number-wrap] .custom-dropdown')?.addEventListener('click', (event) => {
            this.querySelector('[data-manufacture-wrap] .custom-dropdown .custom--select').classList.remove('open');
            this.querySelector('[data-type-wrap] .custom-dropdown .custom--select').classList.remove('open');
           
            this.querySelector('[data-manufacture-wrap] .custom-dropdown.custom--select').classList.remove('open');
            this.querySelector('[data-type-wrap] .custom-dropdown.custom--select').classList.remove('open');
           
            this.querySelector('[data-manufacture-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
            this.querySelector('[data-type-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
         
        });
    }
    
    _searchVehicle(){
        let selectedEqipType = document.querySelector('[data-heavy-category-select-filter] [name="heavy-filter-type"]:checked').value;
        let selectedEqipManufacturer = document.querySelector('[data-heavy-manufacturer-select-filter] [name="heavy-filter-manufacturer"]:checked').value;
        let selectedEqipModel = document.querySelector('[data-heavy-model-select-filter] [name="heavy-filter-model-number"]:checked').value;

        var prefixedParts = this.selectedPartNumber.map(function(element) {
            return "sku-" + element;
        });
        var partsNumber = prefixedParts.join(",");

        this._redirectToParts(partsNumber);      

        document.querySelector('[data-shop-heavy-btn]')?.classList.remove('loading');
        document.querySelector('[data-shop-heavy-btn-new]')?.classList.remove('loading')

    }

    _addVehicle(){
        const isCustomer = document.body.classList.contains('customer-loggedin');
        // const isCustomerB2B = document.body.classList.contains('b2b-customer');
        var prefixedParts = this.selectedPartNumber.map(function(element) {
            return "sku-" + element;
        });
        var partsNumber = prefixedParts.join(",");

        let selectedEqipType = document.querySelector('[data-heavy-category-select-filter] [name="heavy-filter-type"]:checked').value;
        let selectedEqipManufacturer = document.querySelector('[data-heavy-manufacturer-select-filter] [name="heavy-filter-manufacturer"]:checked').value;
        let selectedEqipModel = document.querySelector('[data-heavy-model-select-filter] [name="heavy-filter-model-number"]:checked').value;
        let selectedEqipTypeLabel = document.querySelector('[data-heavy-category-select-filter] [name="heavy-filter-type"]:checked').getAttribute('data-label');
        let selectedEqipManufacturerLabel = document.querySelector('[data-heavy-manufacturer-select-filter] [name="heavy-filter-manufacturer"]:checked').getAttribute('data-label');
        let selectedEqipModelLabel = document.querySelector('[data-heavy-model-select-filter] [name="heavy-filter-model-number"]:checked').getAttribute('data-label');
      
        let selectedData;
        var isVehicleAdded = this.selectedHeavyEqipData.some((selectedVehicle) => {
            return selectedVehicle.equipment_category === selectedEqipType && 
                   selectedVehicle.equipment_manufacturer === selectedEqipManufacturer && 
                   selectedVehicle.equipment_model_number === selectedEqipModel;
        });

        const min = 1000;
        const max = 5000;
        const randomNum = Math.floor(Math.random() * (max - min + 1)) + min;
        if(!isVehicleAdded){
            if(isCustomer){
                selectedData = {
                    "id": randomNum,
                    "equipment_category":selectedEqipTypeLabel,
                    "equipment_manufacturer":selectedEqipManufacturerLabel,
                    "equipment_model_number":selectedEqipModelLabel,
                    "default":this.defaultVehicle
                }
                this.selectedHeavyEqipData.push(selectedData);
                localStorage.setItem('currentSelectedDataLabels', JSON.stringify(selectedData))
                localStorage.setItem('currentSelectedData', JSON.stringify(selectedData))


                //shopifyFormUtility._shopifyHEFormSubmit(this.selectedHeavyEqipData,partsNumber);
                shopifyFormUtility._updateCustomerHEMeta(this.selectedHeavyEqipData,partsNumber);

                setTimeout(() => {
                    let vehicleMeta = document.querySelector('[data-vehile-customer-metafields] [data-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedYMMData = vehicleMeta != '' ? JSON.parse(vehicleMeta) : [];
                  
                    let heavyMeta = document.querySelector('[data-vehile-customer-metafields] [data-hevay-equp-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedHeavyEqipData = heavyMeta != '' ? JSON.parse(heavyMeta) : [];
                    localStorage.removeItem('vehicle_data');
                    localStorage.removeItem('heavy_equipment_data')
                    vehicleUtility._listVehicle();
                    
                    this._redirectToParts(partsNumber);
                    document.querySelector('[data-shop-heavy-btn]')?.classList.remove('loading');
                    document.querySelector('[data-shop-heavy-btn-new]')?.classList.remove('loading')
                    
                },3000)
                
                
            } else {
                selectedData = {
                    "id": randomNum,
                    "equipment_category":selectedEqipType,
                    "equipment_manufacturer":selectedEqipManufacturer,
                    "equipment_model_number":selectedEqipModel,
                    "default":this.defaultVehicle
                }
                this.selectedHeavyEqipData.push(selectedData);

                var prefixedParts = this.selectedPartNumber.map(function(element) {
                    return "sku-" + element;
                });
                var partsNumber = prefixedParts.join(",");

                let selectedEqipTypeLabel = document.querySelector('[data-heavy-category-select-filter] [name="heavy-filter-type"]:checked').getAttribute('data-label');
                let selectedEqipManufacturerLabel = document.querySelector('[data-heavy-manufacturer-select-filter] [name="heavy-filter-manufacturer"]:checked').getAttribute('data-label');
                let selectedEqipModelLabel = document.querySelector('[data-heavy-model-select-filter] [name="heavy-filter-model-number"]:checked').getAttribute('data-label');

                var selectedHeavyLables = {
                    "id": randomNum,
                    "equipment_category":selectedEqipTypeLabel,
                    "equipment_manufacturer":selectedEqipManufacturerLabel,
                    "equipment_model_number":selectedEqipModelLabel,
                    "default":this.defaultVehicle
                }
                
                localStorage.setItem('currentSelectedDataLabels', JSON.stringify(selectedHeavyLables))
                localStorage.setItem('currentSelectedData', JSON.stringify(selectedData))

                localStorage.setItem('heavy_equipment_data', JSON.stringify(this.selectedHeavyEqipData))
                const addedVehicleData = localStorage.getItem('vehicle_data');
                this.selectedYMMData = addedVehicleData ? JSON.parse(addedVehicleData) : [];

                vehicleUtility._listVehicle();
                this._redirectToParts(partsNumber);
                setTimeout(() => {
                    document.querySelector('[data-shop-heavy-btn]')?.classList.remove('loading');
                    document.querySelector('[data-shop-heavy-btn-new]')?.classList.remove('loading')
                }, 3000)
            }
        } else {
            this._redirectToParts(partsNumber);      
        }
    
    }

    _editHEVehicle(_this){
        var prefixedParts = this.selectedPartNumber.map(function(element) {
            return "sku-" + element;
        });
        var partsNumber = prefixedParts.join(",");
        
        let idToUpdate = _this.closest('#change-vehicle').getAttribute('data-id');
        let selectedEqipType = document.querySelector('#change-vehicle [data-heavy-category-select-filter] .selected [name="heavy-filter-type"]').value;
        let selectedEqipManufacturer = document.querySelector('#change-vehicle [data-heavy-manufacturer-select-filter] .selected [name="heavy-filter-manufacturer"]').value;
        let selectedEqipModel = document.querySelector('#change-vehicle [data-heavy-model-select-filter] .selected [name="heavy-filter-model-number"]').value;
       
        let isCustomer = document.body.classList.contains('customer-loggedin');


        for (let i = 0; i <  this.selectedHeavyEqipData.length; i++) {
            if (this.selectedHeavyEqipData[i].id == idToUpdate) {
                this.selectedHeavyEqipData[i].equipment_category = selectedEqipType;
                this.selectedHeavyEqipData[i].equipment_manufacturer = selectedEqipManufacturer;
                this.selectedHeavyEqipData[i].equipment_model_number = selectedEqipModel;
            }  
        }  


        let selectedData = {
            "id": idToUpdate,
            "equipment_category":selectedEqipType,
            "equipment_manufacturer":selectedEqipManufacturer,
            "equipment_model_number":selectedEqipModel
        }

        if(isCustomer){
            // shopifyFormUtility._shopifyHEFormSubmit(this.selectedHeavyEqipData);
            shopifyFormUtility._updateCustomerHEMeta(this.selectedHeavyEqipData);


            let vehicleMeta = document.querySelector('[data-vehile-customer-metafields] [data-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
            this.selectedYMMData = vehicleMeta != '' ? JSON.parse(vehicleMeta) : [];
            
            let heavyMeta = document.querySelector('[data-vehile-customer-metafields] [data-hevay-equp-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
            this.selectedHeavyEqipData = heavyMeta != '' ? JSON.parse(heavyMeta) : [];
            
            let sideMeta = document.querySelector('[data-vehile-customer-metafields] [data-side-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
            this.selectedSideYMMData = sideMeta != '' ? JSON.parse(sideMeta) : [];

            let turfMeta = document.querySelector('[data-vehile-customer-metafields] [data-turf-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
            this.selectedTrufData = turfMeta != '' ? JSON.parse(turfMeta) : [];

            vehicleUtility._listAccountVehicle();
            const vehicleElement = document.querySelector('shop-vehicle');
        
            // Check if the element exists and call the method
            if (vehicleElement && typeof vehicleElement._listVehicleEvents === 'function') {
                vehicleElement._listVehicleEvents();
            } 

            setTimeout(()=>{
                this._redirectToParts(partsNumber);

                document.querySelector('[data-edit-shop-heavy-btn]').classList.remove('loading');
            },1500)
        } else {
            localStorage.setItem('heavy_equipment_data', JSON.stringify(this.selectedHeavyEqipData))
            this._redirectToParts(partsNumber);

        }
        localStorage.setItem('currentSelectedData', JSON.stringify(selectedData))
        localStorage.setItem('currentSelectedDataLabels', JSON.stringify(selectedData))

        document.querySelector('#change-vehicle').show();

    }

    _redirectToParts(partsNumber){
        if(partsNumber != undefined){
            window.location.href=`/collections/all?filter.p.tag=${partsNumber}`;
        }
        else{
            window.location.href=`/collections/all?filter.p.tag=`;
        }
    }

    _populateSelect(select, options, selectBoxName){
        select.innerHTML = "";
        let optionHTML = "";

        options.sort().forEach((option) => {
          if (option !== null) {

            let option_val = Utility._createSlug(option);
            optionHTML += `
            <li class="for-check" data-value="${option}">
                <input type="radio" class="heavy-input form-check-input d-none" value="${option}" id="heavy-${option}" data-label="${option}" name="heavy-filter-${selectBoxName}"/>
                <label class="option_txt form-check-label text-capitalize" for="heavy-${option}" title="Label for ${option}">${option}</label>
            </li>`;
            select.removeAttribute('disabled','disabled');
            select.closest('.custom-dropdown').classList.remove('disabled')
          }
        });
     
        select.innerHTML = optionHTML;

        this._updateDropdown();
    }

    _populateSelectPart(select, options, selectBoxName){
        select.innerHTML = "";
        let optionHTML = "";

        options.sort().forEach((option) => {
          if (option !== null) {    
            let option_val = Utility._createSlug(option)

            optionHTML += `
            <li class="for-check" data-value="${option}">
                <input type="radio" class="heavy-input form-check-input d-none" value="${option}" id="heavy-${option}" data-label="${option}" name="heavy-filter-${selectBoxName}"/>
                <label class="option_txt form-check-label text-capitalize" for="heavy-${option}" title="Label for ${option}">${option}</label>
            </li>`;
            select.removeAttribute('disabled','disabled');
            select.closest('.custom-dropdown').classList.remove('disabled')
          }
        });
     
        select.innerHTML = optionHTML;

        this._updateDropdown();
    }

    _updateManufacture(inputValue){
        let selectedCategory = inputValue;
        
        // Filter available options based on user selections
        const filteredManufacturer = this.uniqueCategory.includes(selectedCategory)
            ? [
                ...new Set(
                Object.values(this.heavyEquipmentJsonData)
                    .filter((item) => item.equipment_category.trim() === selectedCategory)
                    .map((item) => item.equipment_manufacturer)
                ),
            ]
            : this.uniqueCategory;

         
        // Populate the selects with filtered options
        this._populateSelect(this.manufacturerSelect, filteredManufacturer,'manufacturer');
    }

    _updateModel(inputValue){
        let selectedManufacturer = inputValue;
        let filteredModel;
        let selectedCategory = document.querySelector('[data-heavy-category-select-filter] [name="heavy-filter-type"]:checked').getAttribute('data-label');
        if(selectedCategory != ''){
             // Filter available options based on user selections
                filteredModel = this.uniqueManufacture.includes(selectedManufacturer)
                ? [
                    ...new Set(
                    Object.values(this.heavyEquipmentJsonData)
                        .filter((item) => item.equipment_manufacturer === selectedManufacturer && item.equipment_category.trim() === selectedCategory)
                        .map((item) => item.equipment_model_number)
                    ),
                ]
                : this.uniqueManufacture;
            // Populate the selects with filtered options
        } else {
            // Filter available options based on user selections
            filteredModel = this.uniqueManufacture.includes(selectedManufacturer)
            ? [
                ...new Set(
                Object.values(this.heavyEquipmentJsonData)
                    .filter((item) => item.equipment_manufacturer === selectedManufacturer)
                    .map((item) => item.equipment_model_number)
                ),
            ]
            : this.uniqueManufacture;
            // Populate the selects with filtered options
        }

        
        this._populateSelect(this.modelNumberSelect, filteredModel,'model-number');
    }

    _updatePart(partSelect){
        let selectedManufacturer = document.querySelector('[data-heavy-manufacturer-select-filter] [name="heavy-filter-manufacturer"]:checked').value;
        let selectedModelNumber = document.querySelector('[data-heavy-model-select-filter] [name="heavy-filter-model-number"]:checked').value;
        let selectedCategory = document.querySelector('[data-heavy-category-select-filter] [name="heavy-filter-type"]:checked').value;

        let selectedManufacturerLabel = document.querySelector('[data-heavy-manufacturer-select-filter] [name="heavy-filter-manufacturer"]:checked').getAttribute('data-label');
        let selectedModelNumberLabel = document.querySelector('[data-heavy-model-select-filter] [name="heavy-filter-model-number"]:checked').getAttribute('data-label');
        let selectedCategoryLabel = document.querySelector('[data-heavy-category-select-filter] [name="heavy-filter-type"]:checked').getAttribute('data-label');


        let filteredParts;

        if(selectedCategory != ''){
            // Filter available options based on user selections
            filteredParts = [
                ...new Set(
                    Object.values(this.heavyEquipmentJsonData)
                        .filter(
                            (item) =>
                                item.equipment_manufacturer == selectedManufacturerLabel &&
                                item.equipment_category == selectedCategoryLabel &&
                                item.equipment_model_number == selectedModelNumberLabel
                        )
                        .map((item) => item.equipment_part_number)
                ),
            ];
               
            // Populate the selects with filtered options
        } else {
            // Filter available options based on user selections
            filteredParts = [
                ...new Set(
                    Object.values(this.heavyEquipmentJsonData)
                        .filter(
                            (item) =>
                                item.equipment_manufacturer == selectedManufacturer &&
                                item.equipment_model_number == selectedModelNumber
                        )
                        .map((item) => item.equipment_part_number)
                ),
            ];
            // Populate the selects with filtered options
        }

        this.selectedPartNumber = filteredParts;

        this._populateSelectPart(partSelect, filteredParts,'part-number');
    }

    _updateDropdown(){
        // Start Manufacturer Dropdown Event
        this.manufacturerSelectInput = this.manufacturerSelect.querySelectorAll('input');
            
        this.manufacturerSelectInput.forEach((manufacturerInput) => {
            manufacturerInput.addEventListener('change', (event) => {
                let _this = event.currentTarget;
                document.querySelector('[data-shop-heavy-btn]')?.classList.add('disabled');
                document.querySelector('[data-edit-shop-heavy-btn]')?.classList.add('disabled');

                let currentvalue = document.querySelector('[data-heavy-manufacturer-select-filter] [name="heavy-filter-manufacturer"]:checked').value;
                let currentvalueLabel = document.querySelector('[data-heavy-manufacturer-select-filter] [name="heavy-filter-manufacturer"]:checked').getAttribute('data-label');
                let els = document.querySelectorAll('shop-heavy-equipment');
                els.forEach(el => {
                    el.querySelector('.heavy-modal-default .option_txt').innerHTML = 'Model Number';
                    el.querySelector('[data-shop-heavy-btn]')?.classList.add('disabled');
                    el.querySelector('[data-shop-heavy-btn-new]')?.classList.add('disabled');
                    el.querySelector('[data-pdp-edit-heavy-btn]')?.classList.add('disabled');
                    el._updateModel(currentvalueLabel);
                });
                //this._updateModel(currentvalue);
            })
        });

        this.manufacturerOptions = this.manufacturerSelect.querySelectorAll('li');
        this.manufacturerOptions.forEach((option) => {
            option.addEventListener('click', (event) => {
                let _this = event.currentTarget;
                this.manufacturerOptions.forEach(option => option.classList.remove('selected'));
                _this.classList.add('selected');
                _this.closest('.custom-dropdown').querySelector('.manufacturer-default .option_txt').innerHTML = _this.querySelector('.option_txt').innerHTML;
                this.selectContainer = _this.closest('.custom--select');
                Utility.toggleElement(this.selectContainer, 'close');
            });
        }) 

        //End Manufacturer Dropdown Event
         //Start Model Dropdwon Event
         this.ModelNumberSelectInput = this.modelNumberSelect.querySelectorAll('input');
         this.ModelNumberSelectInput.forEach((modelNumberInput) => {
             modelNumberInput.addEventListener('change', (event) => {
                document.querySelector('[data-shop-heavy-btn]')?.classList.remove('disabled');
                document.querySelector('[data-edit-shop-heavy-btn]')?.classList.remove('disabled');

                let els = document.querySelectorAll('shop-heavy-equipment');
                els.forEach(el => {
                    el.querySelector('[data-shop-heavy-btn]')?.classList.remove('disabled');
                    el.querySelector('[data-shop-heavy-btn-new]')?.classList.remove('disabled');
                    el.querySelector('[data-pdp-edit-heavy-btn]')?.classList.remove('disabled');
                    el._updatePart(el.querySelector('[data-equipment-part-filter-select]'));
                });
                this._updatePart(this.partNumberSelect);
             })
         });
 
         this.modelNumberOptions = this.modelNumberSelect.querySelectorAll('li');
         this.modelNumberOptions.forEach((option) => {
             option.addEventListener('click', (event) => {
                 let _this = event.currentTarget;
                 this.modelNumberOptions.forEach(option => option.classList.remove('selected'));
                 _this.classList.add('selected');
                 _this.closest('.custom-dropdown').querySelector('.heavy-modal-default .option_txt').innerHTML = _this.querySelector('.option_txt').innerHTML;
                 this.selectContainer = _this.closest('.custom--select');
                 Utility.toggleElement(this.selectContainer, 'close');
             });
         }) 
         //End Model Dropdwon Event
    }
}

customElements.define('shop-heavy-equipment', heJS);


